import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const DatabaseResourceFallback = () => (
  <div className="flex items-end gap-4 w-full">
    <div className="w-full">
      <Label>Resource</Label>
      <Skeleton className="h-9 w-full mt-2" />
    </div>
  </div>
)
